<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <div class="related-factors-select-group">
          <div style="display:flex;gap:10px;align-items:center;">
            <label style="font-size:.875em;color:#606266;">因子1:</label>
            <el-cascader
              v-model="factorId1"
              placeholder="选择分子"
              size="small"
              style="width:120px;height:32px;"
              :options="factorTree.length === 1 ? factorTree[0].children : factorTree"
              :show-all-levels="false"
              :props="{
                emitPath: false,
                expandTrigger: 'hover',
                value: 'id',
                label: 'name'
              }"
            />
          </div>

          <div style="display:flex;gap:10px;align-items:center;">
            <label style="font-size:.875em;color:#606266;">因子2:</label>
            <el-cascader
              v-model="factorId2"
              placeholder="选择分母"
              size="small"
              style="width:120px;height:32px;"
              :options="factorTree.length === 1 ? factorTree[0].children : factorTree"
              :show-all-levels="false"
              :props="{
                emitPath: false,
                expandTrigger: 'hover',
                value: 'id',
                label: 'name'
              }"
            />
          </div>
        </div>

        <unit-switch :default-unit-prop.sync="unitProp" @change="onUnitPropChange" />
      </template>

      <related-chart-group
        v-for="data in dataList"
        :key="data.id"
        :data-config="data"
        :related-opts="allRelatedOpts"
        :unit-prop="unitProp"
        :audit-rule-flag-map="auditRuleFlagMap"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../../model/DeviceCategoryConfig'
import {mapGetters} from 'vuex'

import LayoutContent from '../../../../../components/Layout/Content'
import DataTimeQuery from '../../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../../components/Data/Query/SiteQuery'
import FactorTreeQuery from '../../../../../components/Data/Query/FactorTreeQuery'
import CompletedQuery from '../../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../../components/Data/UnitSwitch'
import RelatedChart from '../../../../../components/Data/RelatedChart'
import RelatedChartGroup from './RelatedChartGroup'

export default {
  name: 'StatisticalAnalysisVOCsHeterogeneous',
  routeInfo: {
    label: '特征物种相关性分析',
    icon: 'fa fa-eye'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, FactorTreeQuery, CompletedQuery, DataWrapper, UnitSwitch, RelatedChart, RelatedChartGroup},
  data: () => ({
    query: {
      isFuse: false,
      isMultipleIntegral: true
    },
    factorId1: null,
    factorId2: null
  }),
  computed: {
    ...mapGetters({
      relatedFactors: 'Factor/relatedFactors',
      auditRuleFlagMap: 'AuditRule/flagMap'
    }),
    isSetAllFactorIds: () => 0,
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, true)
    ],
    relatedOpts () {
      let {filterFactorMap} = this

      return this.relatedFactors.reduce((list, relatedFactorConfig) => {
        let {factorId} = relatedFactorConfig
        let factor = filterFactorMap[factorId]

        if (factor) {
          let {relatedFactorId} = relatedFactorConfig
          let relatedFactor = filterFactorMap[relatedFactorId]

          if (relatedFactor) {
            list.push({
              value: `${factorId}-${relatedFactorId}`,
              label: `${factor.name} VS ${relatedFactor.name}`,
              id1: factorId,
              id2: relatedFactorId,
              relatedHigh: relatedFactorConfig.relatedHigh,
              relatedLow: relatedFactorConfig.relatedLow
            })
          }
        }

        return list
      }, [])
    },
    allRelatedOpts () {
      let {factorId1} = this

      if (!factorId1) {
        return this.relatedOpts
      }

      let {factorId2} = this

      if (!factorId2) {
        return this.relatedOpts
      }

      let {filterFactorMap} = this

      return [...this.relatedOpts, {
        value: `${factorId1}-${factorId2}`,
        label: `${filterFactorMap[factorId1].name} VS ${filterFactorMap[factorId2].name}`,
        id1: factorId1,
        id2: factorId2,
        relatedHigh: null,
        relatedLow: null
      }]
    },
    requiredFactorIds () {
      return this.allRelatedOpts.reduce((list, relatedOpt) => {
        list.push(relatedOpt.id1, relatedOpt.id2)
        return list
      }, [])
    }
  },
  methods: {
    // onAuditCompletedChanged () {
    //   let {query} = this
    //   if (query.isAuditCompleted === 'isFuse') {
    //     query.isFuse = true
    //     delete query.isAuditCompleted
    //   } else {
    //     query.isFuse = false
    //   }
    //   if (query.isAuditCompleted === true) {
    //     query.isGetInvalidData = false
    //   } else {
    //     query.isGetInvalidData = true
    //   }
    //   query.isMultipleIntegral = false
    //   this.afterSetSiteIds()
    // }
  }
}
</script>

<style lang="scss" scoped>
.related-factors-select-group {
  display: flex;
  gap: 20px;
  align-items: center;
}
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/00VOCs/05Heterogeneous/index.vue